
import { Component, Vue, Prop } from "vue-property-decorator";
import NavBar from "./header.vue";
@Component({
  components: {
    NavBar,
  },
})
export default class Logout extends Vue {
  @Prop({ type: Number, default: null }) public ncSceneId;
  public objData!: any;
  public nc: any = "";
  public ncScene: any = "";
  public ncSceneList = [
    "nc_login",
    "nc_register",
    "nc_login",
    "nc_login",
    "nc_login",
  ];
  public unbundleShow = false;
  public hintText = "";
  public mounted() {
    this.ncScene = this.ncSceneList[this.ncSceneId];
    this.init();
  }
  public init() {
    const self = this;
    const ncToken = [
      "FFFF0N0000000000A1C3",
      new Date().getTime(),
      Math.random(),
    ].join(":");
    const NcOpt = {
      renderTo: "#nc",
      appkey: "FFFF0N0000000000A1C3",
      scene: self.ncScene,
      token: ncToken,
      customWidth: 302,
      trans: { key1: "code0" },
      elementID: ["usernameID"],
      is_Opt: 0,
      language: "cn",
      isEnabled: true,
      timeout: 3000, // 内部网络请求的超时时间。一般情况建议保持默认值（3000ms）。
      times: 10, // 允许服务器超时重复次数，默认5次。超过重复次数后将触发报错。
      hideErrorCode: true,
      fontSize: 20,
      test: "code0",
      callback(data) {
        const param = {
          nctoken: ncToken,
          sessionid: data.csessionid,
          sig: data.sig,
          scene: self.ncScene,
        };
        self.$emit("getParam", param);
      },
    };
    this.nc = (window as any).noCaptcha(NcOpt);
    this.nc.upLang("cn", {
      LOADING: "加载中...",
      _startTEXT: "请按住滑块，拖动到最右边",
      _yesTEXT: "验证通过",
      _error300:
        '哎呀，出错了，点击<a href="javascript:__nc.reset()">刷新</a>再来一次',
      _errorNetwork:
        '网络不给力，请<a href="javascript:__nc.reset()">点击刷新</a>',
    });
  }
  public reset() {
    this.nc.reset();
  }
  public drawVack(id) {
    this.$emit("login", id);
  }
  // 返回上一页
  public onGoBack() {
    this.$emit("onGoBack", true);
  }
}
